import { Component, Inject, inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { NgxToastrService } from '../_services/ngx-toastr/ngx-toastr.service';
import { LoadingService } from '../services/loading.service';
import { NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { HttpServiceService } from '../services/http-service.service';

@Component({
  selector: 'app-forgot-password',
  imports: [ReactiveFormsModule, RouterModule, NgIf],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent implements OnDestroy{  
  forgotForm: FormGroup;
  logo : string | null = '';
  loadingService = inject(LoadingService);
  private httpService = inject(HttpServiceService); 
  private resetPasswordSubscription : Subscription | undefined;
  
    constructor(private fb: FormBuilder, private router : Router, private alertService: NgxToastrService){
      this.forgotForm = this.fb.group({
        email: ['', [Validators.required, Validators.email]]
      });
    }

    ngOnInit(){
      this.logo = this.httpService.getLogoUrl() ?? "";
    }

    onSubmit(){
      if (this.forgotForm.valid) {
        this.resetPasswordSubscription = this.httpService.forgotPassword(this.forgotForm.value).subscribe({
          next : (response) => {
            this.forgotForm.reset();
          this.alertService.success(response.message, "toast-top-right");
          },
          error : (error) => {
          }
        })
      }
    }

    ngOnDestroy(): void {
      this.resetPasswordSubscription?.unsubscribe();
    }

}
